import { t } from "i18next";
import * as Yup from "yup";

export const signinValidationSchema = () =>
  Yup.object().shape({
    emailOrUserName: Yup.string()
      .required(t("form.validation.emailOrUserName")!)
      .max(50," ")
      .min(3," "),
    password: Yup.string()
      .required(t("form.validation.password")!)
      .max(20," ")
      .min(8," "),
  });
